// LIBRARIES

//REDUX
import { createSlice } from "@reduxjs/toolkit";
import { getAllUsers } from "api/userApi";
import dayjs from "dayjs";

//MISC
import {
  IGetAllUser,
  IUsersApiParams,
  UsersTableData,
} from "models/interfaces";

export interface IUserInitialState {
  user: IGetAllUser;
  isLoading: boolean;
  errorMessage: string;
  usersTotalPages: number;
  usersTableData: UsersTableData[];
  usersFilters: IUsersApiParams;
  selectedUsersReportType: string;
}

const initialState: IUserInitialState = {
  user: {
    content: [],
    pageable: {
      sort: {
        empty: false,
        sorted: false,
        unsorted: false,
      },
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
      paged: false,
      unpaged: false,
    },
    totalPages: 0,
    totalElements: 0,
    last: false,
    size: 0,
    number: 0,
    sort: {
      empty: false,
      sorted: false,
      unsorted: false,
    },
    numberOfElements: 0,
    first: false,
    empty: false,
  },
  isLoading: false,
  errorMessage: "",
  usersTotalPages: 0,
  usersTableData: [],
  usersFilters: {
    fullName: {
      usernameOrPhoneNumber: "",
    },
    userStatus: "",
    startDate: "",
    endDate: "",
    page: "",
  },
  selectedUsersReportType : ""
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    toggleUsersFiltersFullNameState: (state, action) => {
      state.usersFilters.fullName = action.payload;
    },
    toggleUsersFiltersUserStatusState: (state, action) => {
      state.usersFilters.userStatus = action.payload;
    },
    toggleusersFiltersValuetartDateState: (state, action) => {
      state.usersFilters.startDate = action.payload;
    },
    toggleUsersFiltersEndDateState: (state, action) => {
      state.usersFilters.endDate = action.payload;
    },
    toggleUsersFiltersPageState: (state, action) => {
      state.usersFilters.page = action.payload;
    },
    toggleClearUsersFiltersState: (state) => {
      state.usersFilters = {
        fullName: {
          usernameOrPhoneNumber: "",
        },
        userStatus: "",
        startDate: "",
        endDate: "",
        page: "",
      };
    },
    toggleClearUsersTableData: (state) => {
      state.usersTableData = null;
    },
    toggleSelectedUsersReportType: (state, action) => {
      state.selectedUsersReportType = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getAllUsers.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getAllUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      let data = action.payload.content;
      let initialData = Array.from({ length: data.length }, () => ({
        username: "",
        phoneNumber: "",
        date: "",
        userStatus: "",
        veriffSessionId: "",
        id: 0,
      }));
      data.forEach((item, index) => {
        initialData[index] = {
          username: item?.fullName || "NO_NAME_PROVIDED",
          phoneNumber: item.username,
          date: dayjs(item.createdAt).format("DD/MM/YYYY"),
          veriffSessionId: item.veriffSessionId ? item.veriffSessionId : "null",
          userStatus: item.userStatus,
          id: item.id,
        };
      });
      state.usersTableData = initialData;
      state.usersTotalPages = action.payload.totalPages;
    });
    builder.addCase(getAllUsers.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
  },
});

export const {
  toggleUsersFiltersFullNameState,
  toggleUsersFiltersUserStatusState,
  toggleusersFiltersValuetartDateState,
  toggleUsersFiltersEndDateState,
  toggleUsersFiltersPageState,
  toggleClearUsersFiltersState,
  toggleClearUsersTableData,
  toggleSelectedUsersReportType,
} = userSlice.actions;

export const user = (state) => state.user.user;
export const userTotalPages = (state) => state.user.usersTotalPages;
export const usersData = (state) => state.user.usersTableData;
export const usersFilters = (state) => state.user.usersFilters;
export const selectedUsersReportTypes = (state) =>
  state.user.selectedUsersReportType;

export default userSlice.reducer;
